import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Mechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-lighter px-4 py-16 md:py-24" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-89">
          <div className="border-2 border-teal rounded-lg p-8 md:p-12 bg-dark/50" data-id="element-90">
            <h2 className="font-bebas text-4xl md:text-6xl text-teal leading-tight mb-6" data-id="element-91">
              EL REINICIO DE RECEPTORES D2
            </h2>

            <div className="space-y-6 text-base md:text-lg leading-relaxed" data-id="element-92">
              <p className="font-inter text-text/90" data-id="element-93">
                No vamos a "moderar" el uso. Vamos a realizar una "limpieza
                química" selectiva. Este protocolo no es motivacional; es
                biológico.
              </p>

              <p className="font-inter text-text/80" data-id="element-94">
                Al aislar los estímulos sintéticos de forma quirúrgica durante 7
                días, obligamos a tus receptores de dopamina a sensibilizarse de
                nuevo.
              </p>

              <p className="font-inter text-text/90 font-semibold" data-id="element-95">
                El resultado: el esfuerzo vuelve a ser gratificante. El enfoque
                vuelve a ser natural. El mundo vuelve a tener color.
              </p>
            </div>
          </div>

          <div className="text-center pt-4" data-id="element-96">
            <a href="#offer" className="group bg-teal hover:bg-teal/90 text-dark font-inter font-bold text-lg px-10 py-5 rounded-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3" data-id="element-97">
              COMENZAR MI REINICIO
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-98" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}